<template>
  <b-dropdown-form
    class="py-1 dropdown-filter-form-n"
  >
    <b-row>
      <b-col cols="10">
        <p>Filters</p>
      </b-col>
      <b-col cols="2">
        <feather-icon
          icon="XIcon"
          size="16"
          class="align-right"
          @click="$emit('emitHideFilter')"
        />
      </b-col>
    </b-row>
    <b-form-group
      label="Agency"
      @click.native.stop
    >
      <v-select
        v-model="agencyFilterValue"
        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
        label="name"
        multiple
        placeholder="Select from list"
        :options="agencyOptions"
        :clearable="false"
        :reduce="o => o.agencyID"
      />
    </b-form-group>
    <b-form-group label="Rank">
      <b-form-checkbox
        v-for="option in rankOptions"
        :key="option"
        v-model="rankFilterValue"
        :value="option"
        name="flavour-3a"
      >
        {{ option }}
      </b-form-checkbox>
    </b-form-group>
    <b-form-group label="Status">
      <b-form-checkbox
        v-for="option in statusOptions"
        :key="option.value"
        v-model="statusFilterValue"
        :value="option.value"
        name="flavour-3a"
      >
        {{ option.label }}
      </b-form-checkbox>
    </b-form-group>
    <b-form-group label="Show">
      <b-form-checkbox
        v-for="option in agentOptions"
        :key="option.value"
        v-model="agentTypeFilterValue"
        :value="option.value"
        name="flavour-3a"
      >
        {{ option.label }}
      </b-form-checkbox>
    </b-form-group>
    <div class="d-flex justify-content-between gap-3 mt-2">
      <b-button
        variant="outline-primary"
        class="mr-1 w-50"
        @click="clearFilter"
      >
        Clear All
      </b-button>
      <b-button
        variant="primary"
        class="w-50"
        @click="applyFilter"
      >
        Apply Filter
      </b-button>
    </div>
  </b-dropdown-form>
</template>

<script>
import {
  BDropdownForm, BFormGroup, BButton, BRow, BCol, BFormCheckbox,
} from 'bootstrap-vue'
import vSelect from 'vue-select'

export default {
  components: {
    BButton,
    BDropdownForm,
    BFormGroup,
    BRow,
    BCol,
    BFormCheckbox,
    vSelect,
  },
  props: {
    agencyFilter: {
      type: [Array, null],
      default: () => [],
    },
    statusFilter: {
      type: [Array, null],
      default: () => [],
    },
    rankFilter: {
      type: [Array, null],
      default: () => [],
    },
    agentTypeFilter: {
      type: [Array, null],
      default: () => [],
    },
    fileStatusOptions: {
      type: Array,
      default: () => [],
    },
    paymentStatusOptions: {
      type: Array,
      default: () => [],
    },
    agencyOptions: {
      type: Array,
      default: () => [],
    },
    statusOptions: {
      type: Array,
      default: () => [],
    },
    rankOptions: {
      type: Array,
      default: () => [],
    },
    agentOptions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      agencyFilterValue: JSON.parse(JSON.stringify(this.agencyFilter)) || [],
      statusFilterValue: JSON.parse(JSON.stringify(this.statusFilter)) || [],
      rankFilterValue: JSON.parse(JSON.stringify(this.rankFilter)) || [],
      agentTypeFilterValue: JSON.parse(JSON.stringify(this.agentTypeFilter)) || [],
    }
  },
  watch: {
    statusFilter: {
      immediate: true,
      handler(val) {
        this.statusFilterValue = JSON.parse(JSON.stringify(val)) || []
      },
    },
    rankFilter: {
      immediate: true,
      handler(val) {
        this.rankFilterValue = JSON.parse(JSON.stringify(val)) || []
      },
    },
    agentTypeFilter: {
      immediate: true,
      handler(val) {
        this.agentTypeFilterValue = JSON.parse(JSON.stringify(val)) || []
      },
    },
    agencyFilter: {
      immediate: true,
      handler(val) {
        this.agencyFilterValue = JSON.parse(JSON.stringify(val)) || []
      },
    },
  },
  methods: {
    applyFilter() {
      this.$emit('update:agencyFilter', this.agencyFilterValue)
      this.$emit('update:statusFilter', this.statusFilterValue)
      this.$emit('update:rankFilter', this.rankFilterValue)
      this.$emit('update:agentTypeFilter', this.agentTypeFilterValue)

      this.$emit('emitHideFilter')
    },
    clearFilter() {
      this.agencyFilterValue = []
      this.statusFilterValue = []
      this.rankFilterValue = []
      this.agentTypeFilterValue = []
      this.$emit('update:agencyFilter', this.agencyFilterValue)
      this.$emit('update:rankFilter', this.rankFilterValue)
      this.$emit('update:statusFilter', this.statusFilterValue)
      this.$emit('update:agentTypeFilter', this.agentTypeFilterValue)

      this.$emit('emitHideFilter')
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
